// monorepo/shared/auth/actions.js
import { authService } from './api';

// Action types
export const AUTH_LOADING = 'AUTH_LOADING';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

// Check authentication status
export const checkAuthAndRedirect = () => async (dispatch) => {
  dispatch({ type: AUTH_LOADING });

  try {
    const response = await authService.checkAuth();
    console.log('Auth check response:', response);

    if (response.authenticated) {
      dispatch({
        type: AUTH_SUCCESS,
        payload: {
          user: response.user,
          permissions: response.permissions || [],
          roles: response.roles || []
        }
      });
      return true;
    } else {
      // Not authenticated - clear any stale tokens and user data
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      dispatch({ type: AUTH_FAILURE });
      return false;
    }
  } catch (error) {
    console.error('Auth check error:', error);
    // Don't show error message for auth check - user just needs to log in
    dispatch({ type: AUTH_FAILURE });
    return false;
  }
};

// Login user
export const loginUser = (credentials) => async (dispatch) => {
  dispatch({ type: AUTH_LOADING });

  try {
    const response = await authService.login(credentials);
    console.log('Login response:', response);

    // Store token if available
    if (response.user && response.user.token) {
      localStorage.setItem('auth_token', response.user.token);
    }

    // Store user info
    localStorage.setItem('auth_user', JSON.stringify(response.user));

    dispatch({
      type: AUTH_SUCCESS,
      payload: {
        user: response.user,
        permissions: response.permissions || [],
        roles: response.roles || []
      }
    });

    return true;
  } catch (error) {
    console.error('Login error:', error);

    // Check if this is a device limit error (403 with specific error code)
    if (error.response?.status === 403 && error.response?.data?.error === 'device_limit_reached') {
      const deviceLimitData = error.response.data;
      dispatch({
        type: AUTH_FAILURE,
        payload: deviceLimitData.message
      });
      // Return full device limit data for the modal
      return {
        type: 'device_limit',
        message: deviceLimitData.message,
        maxDevices: deviceLimitData.max_devices,
        activeDevices: deviceLimitData.active_devices,
        canEmergencyRevoke: deviceLimitData.can_emergency_revoke,
        emergencyRevokeCooldownHours: deviceLimitData.emergency_revoke_cooldown_hours
      };
    }

    // Check if account is deactivated
    if (error.response?.status === 403 && error.response?.data?.error === 'account_deactivated') {
      dispatch({
        type: AUTH_FAILURE,
        payload: error.response.data.message
      });
      return false;
    }

    dispatch({
      type: AUTH_FAILURE,
      payload: error.response?.data?.error || 'Login failed'
    });
    return false;
  }
};

// Alias for OAuth success page
export const checkAuth = checkAuthAndRedirect;

// Logout user
export const logoutUser = () => async (dispatch) => {
  try {
    await authService.logout();
  } finally {
    // Clear local storage
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    
    dispatch({ type: AUTH_LOGOUT });
  }
};